import { render, staticRenderFns } from "./FancyBox.vue?vue&type=template&id=65769250&scoped=true&"
import script from "./FancyBox.vue?vue&type=script&lang=js&"
export * from "./FancyBox.vue?vue&type=script&lang=js&"
import style0 from "./FancyBox.vue?vue&type=style&index=0&id=65769250&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65769250",
  null
  
)

component.options.__file = "FancyBox.vue"
export default component.exports